import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { usersActions } from "../actions/users.actions";
import { history } from "../helpers/history";
import { Grid } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import CircularProgress from "@material-ui/core/CircularProgress";

const jwtDecode = require("jwt-decode");

export default function LoginCallback() {
  const dispatch = useDispatch();
  const [error, setError] = useState(null);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");
    const errorParam = urlParams.get("error");

    if (errorParam) {
      setError(errorParam);
      setTimeout(() => {
        history.push("/login?error=" + errorParam);
      }, 100);
      return;
    }

    if (token) {
      try {
        const decoded = jwtDecode(token);
        const user = { token, decoded };
        localStorage.setItem("user", JSON.stringify(user));
        dispatch(usersActions.loginWithToken(user));
        history.push("/");
      } catch (e) {
        setError("invalid_token");
        setTimeout(() => {
          history.push("/login?error=auth_failed");
        }, 100);
      }
    } else {
      history.push("/login?error=no_token");
    }
  }, [dispatch]);

  if (error) {
    return (
      <div className={"login"}>
        <div className={"left-container"}></div>
        <div className={"right-container"}>
          <Grid container display="flex" alignItems="center" justify="center" id={"loginFormContainer"}>
            <Grid item>
              <Box mb={4}>
                <p className={"text-center"}>Redirection en cours...</p>
              </Box>
            </Grid>
          </Grid>
        </div>
      </div>
    );
  }

  return (
    <div className={"login"}>
      <div className={"left-container"}></div>
      <div className={"right-container"}>
        <Grid container display="flex" alignItems="center" justify="center" id={"loginFormContainer"}>
          <Grid item>
            <Box mb={4}>
              <img
                src={require("../assets/images/login/onduline-logo.svg")}
                alt={"Logo Onduline"}
              />
            </Box>
            <Box mb={4} style={{ textAlign: "center" }}>
              <CircularProgress />
              <p className={"text-center"}>Connexion en cours...</p>
            </Box>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}
